import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import api from '../services/api';

const INK = '#18140C';
const INK3 = '#7A7268';
const MUTED = '#685840';
const BG = '#FAF8F5';
const BD = '#E8E0D0';
const GRN = '#2E7D4F';
const TEAL = '#1A6B54';

const PAY_METHOD = {
  wechat_pay: '微信支付', alipay: '支付宝', bank_transfer: '银行转账', balance: '保证金余额',
};

function fmt(d) { return d ? new Date(d).toLocaleString('zh-CN') : '—'; }

export default function PaymentVouchers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/orders', { params: { limit: 100 } })
      .then(({ data }) => {
        const list = data.data || data || [];
        setRows(list.filter(o => o.paid_at)); // 已付款才有凭证
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: 80 }}><Spin size="large" /></div>;

  return (
    <div style={{ background: BG, minHeight: '100vh', padding: '20px 16px 40px', fontFamily: 'var(--sans,sans-serif)' }}>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: INK, marginBottom: 4 }}>支付凭证</h2>
        <p style={{ fontSize: 12, color: INK3, marginBottom: 18 }}>已付款订单的支付凭证，可长按 / 截图保存</p>

        {rows.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '70px 20px', color: INK3 }}>
            <div style={{ fontSize: 44, marginBottom: 14, opacity: .25 }}>🧾</div>
            <div style={{ fontSize: 14 }}>暂无已付款订单</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {rows.map(o => {
              const title = o.title_zh || o.title_ja || o.lot_title || '拍品';
              const amount = Number(o.total_amount_cny || 0);
              return (
                <div key={o.id} style={{ background: '#fff', border: `1px solid ${BD}`, borderRadius: 12, overflow: 'hidden' }}>
                  {/* 凭证头 */}
                  <div style={{
                    padding: '12px 16px', background: 'linear-gradient(135deg, #1A2E28, #2A4A3E)',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}>
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>支付凭证</span>
                    <span style={{ fontSize: 12, color: '#8FD4B4', display: 'inline-flex', alignItems: 'center', gap: 4 }}>✓ 已支付</span>
                  </div>
                  {/* 金额 */}
                  <div style={{ padding: '16px', textAlign: 'center', borderBottom: `1px solid ${BD}40` }}>
                    <div style={{ fontSize: 12, color: MUTED }}>支付金额（人民币）</div>
                    <div style={{ fontSize: 28, fontWeight: 700, color: TEAL, fontFamily: 'var(--mono,monospace)', marginTop: 2 }}>
                      ¥{amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                  </div>
                  {/* 明细 */}
                  <div style={{ padding: '8px 16px 14px' }}>
                    {[
                      ['订单号', o.order_no || o.id?.slice(0, 8)],
                      ['拍品', title],
                      ['支付方式', PAY_METHOD[o.payment_method] || o.payment_method || '—'],
                      ['支付时间', fmt(o.paid_at)],
                    ].map(([k, v]) => (
                      <div key={k} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '7px 0', borderBottom: `1px solid ${BD}30` }}>
                        <span style={{ fontSize: 12, color: MUTED, flexShrink: 0 }}>{k}</span>
                        <span style={{ fontSize: 13, color: INK, textAlign: 'right', wordBreak: 'break-all' }}>{v}</span>
                      </div>
                    ))}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 10, fontSize: 11, color: GRN }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: GRN }} />
                      云川中古 · 日本拍卖代行
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <p style={{ fontSize: 11, color: INK3, marginTop: 16, lineHeight: 1.6 }}>
          * 本凭证为平台支付记录，仅供对账参考；正式发票 / 请求书如有需要请联系客服。
        </p>
      </div>
    </div>
  );
}
